module.exports = __webpack_public_path__ + "static/media/49bumba.576e50c6.mp3";